import Layout from '@/layout'

const dataRouter = {
  path: '/data',
  component: Layout,
  redirect: '/data/warehouse-entry-list',
  name: 'Data',
  meta: {
    title: '数据管理',
    icon: 'el-icon-s-data'
  },
  children: [
    {
      path: 'sales-statistics',
      component: () => import('@/views/data/sales-statistics'),
      name: 'SalesStatistics',
      meta: { title: '销售成本统计' }
    },
    {
      path: 'sales-product-detail',
      component: () => import('@/views/data/sales-product-detail'),
      name: 'SalesProductDetail',
      meta: { title: '销售产品明细统计', hidden: true }
    },
    {
      path: 'purchase-statistics',
      component: () => import('@/views/data/purchase-statistics'),
      name: 'PurchaseStatistics',
      meta: { title: '采购情况统计' }
    },
    {
      path: 'warehouse-entry-list',
      component: () => import('@/views/finance/warehouse-entry-list'),
      name: 'WarehouseEntryList',
      meta: { title: '入库明细表' }
    },
    {
      path: 'warehouse-outbound-list',
      component: () => import('@/views/finance/warehouse-outbound-list'),
      name: 'WarehouseOutboundList',
      meta: { title: '出库明细表' }
    },
    {
      path: 'accounts-receivable-summary',
      component: () => import('@/views/data/accounts-receivable-summary'),
      name: 'AccountsReceivableSummary',
      meta: { title: '应收账款汇总表' }
    },
    {
      path: 'accounts-receivable-summary-detail',
      component: () => import('@/views/data/accounts-receivable-summary-detail'),
      name: 'AccountsReceivableSummaryDetail',
      meta: { title: '应收账款明细表', hidden: true }
    },
    {
      path: 'accounts-payable-summary',
      component: () => import('@/views/data/accounts-payable-summary'),
      name: 'AccountsPayableSummary',
      meta: { title: '应付账款汇总表' }
    },
    {
      path: 'accounts-payable-summary-detail',
      component: () => import('@/views/data/accounts-payable-summary-detail'),
      name: 'AccountsPayableSummaryDetail',
      meta: { title: '应付账款明细表', hidden: true }
    },
    {
      path: 'product-settlement-sales-statistics',
      component: () => import('@/views/data/product-settlement-sales-statistics'),
      name: 'ProductSettlementSalesStatistics',
      meta: { title: '产品明细销售统计' }
    },
    {
      path: 'product-purchase-inbound-detail',
      component: () => import('@/views/data/product-purchase-inbound-detail'),
      name: 'ProductPurchaseInboundDetail',
      meta: { title: '商品入库明细表' }
    },
    {
      path: 'product-sales-outbound-detail',
      component: () => import('@/views/data/product-sales-outbound-detail'),
      name: 'ProductSalesOutboundDetail',
      meta: { title: '商品出库明细表' }
    },
    {
      path: 'settlement-sales-summary',
      component: () => import('@/views/data/settlement-sales-summary'),
      name: 'SettlementSalesSummary',
      meta: { title: '销售汇总表' }
    },
    {
      path: 'settlement-sales-summary-detail',
      component: () => import('@/views/data/settlement-sales-summary-detail'),
      name: 'SettlementSalesSummaryDetail',
      meta: { title: '销售汇总表明细', hidden: true }
    },
    {
      path: 'settlement-purchase-summary',
      component: () => import('@/views/data/settlement-purchase-summary'),
      name: 'SettlementPurchaseSummary',
      meta: { title: '采购汇总表' }
    },
    {
      path: 'settlement-purchase-summary-detail',
      component: () => import('@/views/data/settlement-purchase-summary-detail'),
      name: 'SettlementPurchaseSummaryDetail',
      meta: { title: '采购汇总表明细', hidden: true }
    }
  ]
}

export default dataRouter
